'use strict';

export class DonationShortcode {
	constructor() {
		// Do not reset #user_paying_currency after load. A 2s write-back of the
		// first-paint (cached) value fought geo preselect and manual switches,
		// leaving chips/dropdown USD while the cart Total stayed ILS.
	}
}
